import type { ReactNode } from "react";

interface SectionHeadingProps {
  kicker: string;
  title: ReactNode;
  desc?: string;
  right?: ReactNode;
  light?: boolean;
}

export default function SectionHeading({ kicker, title, desc, right, light }: SectionHeadingProps) {
  return (
    <div className="mb-8 md:mb-10">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div className="max-w-2xl">
          <div className="mb-3 flex items-center gap-2">
            <span className="inline-block h-2.5 w-2.5 rotate-45 bg-accent-500" />
            <span className="font-label text-xs font-semibold uppercase tracking-[0.22em] text-primary-600">
              {kicker}
            </span>
          </div>
          <h2 className="display-serif text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
            {title}
          </h2>
          {desc ? (
            <p className={`mt-3 text-sm leading-7 md:text-base ${light ? "text-foreground-300" : "text-foreground-600"}`}>
              {desc}
            </p>
          ) : null}
        </div>
        {right ? <div className="shrink-0">{right}</div> : null}
      </div>
    </div>
  );
}